import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./PortalOrdersDrawerItemsMain";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import { userClaimInformation } from "../../../models/usersModel";
import { useSelector } from "react-redux";
import { View } from "../../../components/shared/Themed";
import Spinner from "../../../components/shared/Spinner";
import CustomerOrderScreen from "../../../screens/Customer/CustomerOrderScreen";
import CustomerOrderSummaryReport from "../../../screens/Customer/partials/CustomerOrderSummaryReport";
import KanbanPOCScreen from "../../../screens/KanbanScreen/KanbanPOCScreen";

const Drawer = createDrawerNavigator();

export default function PortalOrdersDrawerNavigator() {
  const [userProfile, setUserProfile] = React.useState<userClaimInformation>();
  const { userInfo, currentRole } = useSelector(
    (state: any) => state.configurations,
  );
  const dimensions = useWindowDimensions();
  const [filteredDrawerItems, setFilteredDrawerItems] =
    React.useState(drawerItemsMain);

  React.useEffect(() => {
    if (userInfo) {
      setUserProfile(userInfo);
    }
  }, [userInfo]);

  if (!userProfile || !currentRole) {
    return (
      <View
        style={{
          flexDirection: "column",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner
          size="small"
          color="#74BBFF"
          styles={{
            flexDirection: "row",
            justifySelf: "center",
            alignSelf: "center",
          }}
        />
      </View>
    );
  }

  return (
    <Drawer.Navigator
      screenOptions={{
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front",
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={filteredDrawerItems} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: "CustomerOrderScreen",
          title: "Customer Order Screen",
        }}
        name="CustomerOrderScreen"
        component={CustomerOrderScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "CustomerOrderSummaryReport",
          title: "Customer Order Summary Report",
        }}
        name="CustomerOrderSummaryReport"
        component={CustomerOrderSummaryReport}
      />

      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          options={{
            drawerLabel: "KanbanPOCScreen",
            title: "KanbanPOCScreen",
          }}
          name="KanbanPOCScreen"
          component={KanbanPOCScreen}
        />
      )}
    </Drawer.Navigator>
  );
}
